import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class DictionaryPhoneNumberCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(String)
  public readonly isoCode!: string;

  @jsonMember(String)
  public readonly prefix!: string;

  @jsonMember(String)
  public readonly createdAt!: Date;
}
